import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Target, Calendar, Home, Users, MessageCircle, LogOut } from 'lucide-react';
import { useAuthStore } from '../../store/authStore';

interface NavItem {
  path: string;
  icon: React.ElementType;
  label: string;
}

const navItems: NavItem[] = [
  { path: '/dashboard', icon: LayoutDashboard, label: 'توازنك' },
  { path: '/dashboard/goals', icon: Target, label: 'اهدافك' },
  { path: '/community', icon: Home, label: 'المجتمع' },
  { path: '/community/friends', icon: Users, label: 'الأصدقاء' },
  { path: '/community/messages', icon: MessageCircle, label: 'الدردشات' },
];

export const MobileNavbar: React.FC = () => {
  const location = useLocation();
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();

  const isActivePath = (path: string) => {
    if (path === '/dashboard' || path === '/community') {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white border-b border-gray-200 lg:hidden z-50">
      <div className="flex justify-around items-center h-14 px-2 gap-2">
        {navItems.map(({ path, icon: Icon }) => (
          <Link
            key={path}
            to={path}
            className={`
              flex items-center justify-center
              w-12 h-12
              rounded-full
              transition-all duration-200
              ${isActivePath(path) ? 'text-primary bg-primary bg-opacity-10' : 'text-gray-500 hover:text-primary hover:bg-gray-100'}
            `}
          >
            <Icon className="w-6 h-6" />
          </Link>
        ))}

        {/* Profile & Logout Icons */}
        <div className="flex items-center gap-2">
          {/* Profile Link */}
          <Link
            to="/profile"
            className={`
              flex items-center justify-center
              w-12 h-12
              rounded-full
              transition-all duration-200
              ${isActivePath('/profile') ? 'text-primary bg-primary bg-opacity-10' : 'text-gray-500 hover:text-primary hover:bg-gray-100'}
            `}
          >
            <div className="w-6 h-6 rounded-full bg-primary bg-opacity-10 flex items-center justify-center overflow-hidden">
              {user?.avatar ? (
                <img src={user.avatar} alt={user.name} className="w-full h-full object-cover" />
              ) : (
                <span className="text-primary font-medium text-xs">{user?.name?.charAt(0)?.toUpperCase()}</span>
              )}
            </div>
          </Link>
          {/* Logout Icon */}
          <button
            onClick={handleLogout}
            className="flex items-center justify-center w-12 h-12 rounded-full text-error hover:text-gray-500 hover:bg-gray-100 transition-all duration-200"
            aria-label="تسجيل الخروج"
          >
            <LogOut className="w-6 h-6" />
          </button>
        </div>
      </div>
    </nav>
  );
};
